export const RequestSentListItems = (email) => [
    "Check the spam messages",
    `Check if entered e-mail ( ${email} )  is correct`,
    "Try to login with third-party option",
    "Speak to our support: support@web3m.io",
]